export default __webpack_public_path__ + "static/media/rank2.6dde35b2.png";